<template>
  <div class="market-couponList-index">
    <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search>
    <div class="fun-btn-box">
      <auth-button auth="market:activity:orderCoupon:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 发券</el-button>
      </auth-button>
    </div>
    <Table
      :tableThData="tableThData"
      :tableTrData="tableTrData"
      :loading="loading"
      :limit="limit"
      :total="total"
      :offset="offset"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
    >
      <template #activityName="{ row }">{{ row.activityName }}</template>
      <template #name="{ row }">{{ row.name }}</template>
      <template #detail="{ row }">{{ row.detail }}</template>
      <template #require="{ row }">{{ row.require }}</template>
      <template #activityTime="{ row }">
        {{ row.activityStartTime ? $moment(row.activityStartTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
        <span> - </span>
        {{ row.activityEndTime ? $moment(row.activityEndTime).format('YYYY/MM/DD HH:mm:ss') : '' }}
      </template>
      <template #useTime="{ row }">{{ row.useTime }}</template>
      <template #useRangeType="{ row }">{{ row.useRangeType }}</template>
      <template #status="{ row }">{{ activityTypeObj[row.status] }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <auth-button auth="market:activity:orderCoupon:update">
          <el-button v-if="!scope.row.disable" class="del" type="text" @click="onChangeStatus(scope.row)">弃用</el-button>
        </auth-button>
      </template>
    </Table>
  </div>
</template>

<script>
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_getAccountCouponGrantList, api_putAccountCouponGrantSwitch } from '@/api/market'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
export default {
  name: "mcgaIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "活动名称",
          placeholder: "请输入活动名称",
          type: "input",
          key: "name",
        },
        {
          label: "活动时间",
          placeholder: ['开始时间', '结束时间'],
          type: "date-range",
          key: "activityDate",
          valueFormat: 'timestamp'
        },
        {
          label: "活动状态",
          placeholder: "请选择活动状态",
          type: "select",
          key: "status",
          option: [
            {label: '未开始', value: 'New'},
            {label: '进行中', value: 'Doing'},
            {label: '已结束', value: 'Ended'},
            {label: '已停止', value: 'Stopped'},
          ]
        },
      ],
      form: {},
      tableThData: [
        { prop: "activityName", label: "活动名称", minWidth: "180", },
        { prop: "name", label: "优惠券名称", minWidth: "180", },
        { prop: "detail", label: "券优惠", minWidth: "120", },
        { prop: "require", label: "券门槛", minWidth: "180", },
        { prop: "activityTime", label: "活动时间", minWidth: "300", },
        { prop: "useTime", label: "用券时间", minWidth: "200", },
        { prop: "useRangeType", label: "使用范围", minWidth: "120", },
        { prop: "status", label: "活动状态", minWidth: "100", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "120", },
        { prop: "operation", label: "操作", minWidth: "120", },
      ],

      activityTypeObj: {
        New: '未开始',
        Doing: '进行中',
        Ended: '已结束',
        Stopped: '已停止',
      }

    };
  },
  created () {
  },
  methods: {
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      params.startTime = this.form.activityDate ? parseInt(this.form.activityDate[0]) : ''
      params.endTime = this.form.activityDate ? parseInt(this.form.activityDate[1]) : ''
      delete params.activityDate

      const data = await api_getAccountCouponGrantList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
    },

    // 点击发券按钮
    onAdd() {
      this.$router.push({
        path: "/market/couponGrant-account/add"
      });
    },

    // 更改券状态
    onChangeStatus(row) {
      this.$baseConfirm(
        '是否确定弃用该优惠券？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_putAccountCouponGrantSwitch({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponList-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }

  .del {
    color: #F74A4A;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }
}
</style>
